module.exports = __webpack_public_path__ + "static/media/blog9_sm.205ca8c4.jpg";